import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import {
  getUserResult,
  getRiasecUserResult,
  getJourdaUserResult,
  getImUserResult,
} from '../api/questionnaires';
import { fetchTivConversations } from '../api/tiv';
import TivHeader from '../components/tiv/TivHeader';
import TivQuestionnaires from '../components/tiv/TivQuestionnaires';
import TivConversations from '../components/tiv/TivConversations';
import TivProfilePanel from '../components/tiv/TivProfilePanel';

export default function TivPage() {
  const { user } = useContext(AuthContext);
  const prenom = user?.firstName || user?.name || '';

  const [showProfile,   setShowProfile]   = useState(false);
  const [loading,       setLoading]       = useState(true);
  const [nbDone,        setNbDone]        = useState(0);
  const [quizDone,      setQuizDone]      = useState([false, false, false, false]);
  const [conversations, setConversations] = useState([]);

  useEffect(() => {
    async function load() {
      try {
        const [v, r, j, im, convs] = await Promise.all([
          getUserResult().catch(() => null),
          getRiasecUserResult().catch(() => null),
          getJourdaUserResult().catch(() => null),
          getImUserResult().catch(() => null),
          fetchTivConversations().catch(() => []),
        ]);
        const done = [!!v, !!r, !!j, !!im];
        setQuizDone(done);
        setNbDone(done.filter(Boolean).length);
        setConversations(Array.isArray(convs) ? convs : []);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center bg-gray-900">
        <div className="w-5 h-5 rounded-full border-2 border-violet-500 border-t-transparent animate-spin" />
      </div>
    );
  }

  const allDone = nbDone === 4;

  return (
    <>
      <div className='flex-1 overflow-y-auto bg-gray-900 flex items-center justify-center'>
        <div className="w-full max-w-lg mx-auto px-4 py-10">
          <TivHeader onProfileClick={() => setShowProfile(true)} />
          {!allDone
            ? <TivQuestionnaires prenom={prenom} nbDone={nbDone} quizDone={quizDone} />
            : <TivConversations prenom={prenom} conversations={conversations} />
          }
        </div>
      </div>
      <TivProfilePanel open={showProfile} onClose={() => setShowProfile(false)} />
    </>
  );
}
